import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Consultant, ConsultantResource } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, SharedDataService, ListItem, ListService } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-consultantresource-edit',
	templateUrl: './consultantresource-edit.component.html',
	styleUrls: ['./consultantresource-edit.component.scss']
})
export class ConsultantresourceEditComponent implements OnInit, OnDestroy {

	loading: boolean = true;
	resource: ConsultantResource;

	editable: boolean = true;

	search: {
		consultant: Search
	};
	selected: {
		consultant: Consultant
	};

	@Input()
	consultantid: number;
	title: string;

	contracttypes: ListItem[] = [];
	contractlevels: ListItem[] = [];
	roles: ListItem[] = [];

	constructor(
		private crudService: CrudService<ConsultantResource>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private consultantService: CrudService<Consultant>,
		private router: Router,
		private activeModal: NgbActiveModal,
		private listService: ListService
	) {


		this.selected = {
			consultant: undefined
		};

		this.search = {
			consultant: new Search('consultant')
		};

		this.listService.getListItemsBySlug('contract.type').subscribe(data => this.contracttypes = data);
		this.listService.getListItemsBySlug('contract.level').subscribe(data => this.contractlevels = data);
		this.listService.getListItemsBySlug('resource.role').subscribe(data => this.roles = data);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			} else {
				this.resource = new ConsultantResource();
				this.title = 'resource-create';
				if (this.consultantid) {
					this.resource.consultantid = this.consultantid;
					this.findConsultant(this.resource.consultantid);
				}

				this.loading = false;
			}

		});
	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.crudService.getEntity(ConsultantResource, 'consultantresource', id).subscribe(resource => {
			this.resource = resource;
			this.title = 'resource-edit';
			this.loading = false;
			this.initItem();
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.consultantresource'));
			this.resource = undefined;
			this.loading = false;
		});
	}


	findConsultant(cid: number): void {
		if (cid) {
			this.consultantService.getEntity(Consultant, 'consultant', cid).subscribe((c: Consultant) => {
				this.selected.consultant = c;
			});
		}
	}


	initItem() {
		this.findConsultant(this.resource.consultantid);
	}

	dismiss() {
		this.activeModal.dismiss();
	}

	submit() {

		if (!this.resource.id) {

			this.crudService.createEntity(ConsultantResource, 'consultantresource', this.resource).subscribe(response => {
				this.resource = response;
				const messages = this.translateService.instant(['labels.resource-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.resource-save-success'], messages['labels.success']);
				this.activeModal.close(this.resource);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.crudService.saveEntity(ConsultantResource, 'consultantresource', this.resource).subscribe(response => {
				this.resource = response;
				this.initItem();
				const messages = this.translateService.instant(['labels.resource-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.resource-save-success'], messages['labels.success']);
				this.activeModal.close(this.resource);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}

}
